import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { css } from '@emotion/react';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'components/field/Button';
import Icon from 'components/global/Icon';
import Image from 'components/global/Image';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalTitle } from 'components/global/styled/Modal.styled';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { setConnectedTokens } from 'pages/APIIntegrations/ConnectedTokens.slice';
import { setConnectedStores } from 'pages/SalesChannels/ConnectedStores/ConnectedStores.slice';
import useSallaSync from 'pages/SalesChannels/useSallaSync';

import { SALES_CHANNELS } from 'services/consts';

import AppLogger from 'utils/AppLogger';
import { PLATFORM } from 'utils/constants';

import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { faRotate } from '@fortawesome/pro-solid-svg-icons';

import * as S from './DeleteStore.styled';

const DeleteStore = NiceModal.create(({ salesChannel }) => {
	const modal = useModal();
	const axiosPrivate = useAxiosPrivate();
	const connectedStoresList = useSelector((state) => state?.connectedStores);
	const { data: tokens } = useSelector((state) => state?.connectedTokens);

	const { showSuccess, showError } = useAlert();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState(false);
	const { restartAutomation } = useSallaSync();
	const removeChannel = async () => {
		setIsLoading(true);
		try {
			const response = await axiosPrivate.post(SALES_CHANNELS.DELETE_SALE_CHANNEL, {
				accountID: salesChannel.ID
			});
			if (response.status === 200) {
				showSuccess();
				if (salesChannel.slug === 'oto-api') {
					dispatch(setConnectedTokens(tokens.filter((item) => item.ID !== salesChannel.ID)));
				} else dispatch(setConnectedStores(connectedStoresList.filter((item) => item.ID !== salesChannel.ID)));
				modal.remove();
				if (
					(salesChannel?.slug === 'salla-automation' && import.meta.env.VITE_PLATFORM === PLATFORM.desktop) ||
					salesChannel?.slug === 'salla-desktop'
				)
					restartAutomation();
			} else {
				AppLogger.error(response);
			}
		} catch (error) {
			AppLogger.error(error);
			showError();
		} finally {
			setIsLoading(false);
		}
	};
	return (
		<Modal maxWidth="x-small" fullwidth closeButton className="remove-channel-confirmation">
			<ModalTitle>
				<Typography variant="p1">removeChannel</Typography>
			</ModalTitle>
			<S.Container>
				<S.LogoContainer>
					<Image width="6rem" height="6rem" url={salesChannel?.icon} />
					<Icon icon={faRotate} fontSize="3rem" />
					<Image
						width="6rem"
						height="6rem"
						url="https://storage.googleapis.com/tryoto-public/public/assets/images/otoLogo.png"
					/>
				</S.LogoContainer>
				<Typography variant="p2" fontWeight="500" noWrap align="center">
					{t('removeChannelConfirmation', {
						channelName: t(`salesChannel.${salesChannel?.integrationName}`)
					})}
				</Typography>
				<Typography variant="p3" color="var(--content-3)" noWrap align="center">
					removeChannelSubtitle
				</Typography>
			</S.Container>
			<ModalActions>
				<Button label="cancel" onClick={() => modal.remove()} variant="action" />
				<Button
					label="removeChannel"
					onClick={removeChannel}
					icon={faTrash}
					css={css`
						background-color: var(--red) !important;
						border-color: var(--red) !important;
					`}
					loading={isLoading}
				/>
			</ModalActions>
		</Modal>
	);
});

export default DeleteStore;
